<template>
  <section>
    <gs-header
      title="Thêm mới user"
      :breadcrumbs="[
        {title: 'Quản lý user', route: {name: 'user'}}
      ]">
    </gs-header>
    <div class="padding-lg-all">
      <el-form :model="localUser" :rules="rules" ref="createUserForm" label-width="200px" label-position="top" @submit.prevent.native="validateBeforeSubmitUser('createUserForm')">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Tên cửa hàng" prop="shop_name">
              <el-input v-model="localUser.shop_name" placeholder="Tên cửa hàng"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Họ tên" prop="name">
              <el-input v-model="localUser.name" placeholder="Họ tên"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Số điện thoại" prop="phone">
              <el-input v-model="localUser.phone" placeholder="Số điện thoại"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Email" prop="email">
              <el-input v-model="localUser.email" placeholder="Email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Mật khẩu" prop="password">
              <el-input type="password" v-model="localUser.password" placeholder="Mật khẩu"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Nhập lại mật khẩu" prop="password_confirmation">
              <el-input type="password" v-model="localUser.password_confirmation" placeholder="Nhập lại mật khẩu"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <button :disabled="submitting" class="ui blue basic small button" native-type="submit">Thêm mới</button>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
import { createUser } from 'src/api/users'
import { head } from 'lodash'
import mixins from './mixins'
export default {

  name: 'NewUser',
  mixins: [mixins],
  methods: {
    validateBeforeSubmitUser () {
      this.submitting = true
      this.$refs.createUserForm.validate(valid => {
        if (valid) {
          this.changedData = false
          createUser(this.localUser).then(response => {
            switch (response.code) {
              case 200:
                this.$store.dispatch('showNotify', {
                  title: 'Thêm mới thành công',
                  body: 'Thêm user  thành công'
                })
                this.reloadGsTableAfterRedirect({name: 'user'}, 'clients')
                this.toggleLoadding(false)
                this.submitting = false
                break
              case 422:
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.toggleLoadding(false)
                this.submitting = false
                break
              default:
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: 'Tạo user thất bại vui lòng kiểm tra lại thông tin',
                  type: 'warning'
                })
                this.toggleLoadding(false)
                this.submitting = false
            }
          })
        } else {
          this.$store.dispatch('toggleLoadding', false, {root: true})
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          this.submitting = false
          return false
        }
      })
    },
    newUser () {
      this.localUser = {
        shop_name: '',
        name: '',
        phone: '',
        email: '',
        password: '',
        password_confirmation: ''
      }
      setTimeout(() => {
        this.watching = true
      }, 100)
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// NewUser.vue?62cf061a